export default {"src":"/_next/static/media/file-upload-success-animation.6c2b68d9.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};